module.exports = __webpack_public_path__ + "img/Asset 30.961b0582.png";